import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { AxiosRequestConfig } from 'axios';
import { Backdrop, CircularProgress } from '@mui/material';
import spinner from 'recoil/atoms/spinner';
import Api from 'utils/api';


const BlockingSpinner = () => {
    const [loading, setLoading] = useRecoilState(spinner);

    useEffect(() => {
        Api.subscribe('beforeCall', (config:  AxiosRequestConfig) => {
            if (config.method === 'get' || config._silently) return;
            setLoading(true);
        });
        Api.subscribe('afterCall', () => setLoading(false));
    }, []);

    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: theme => theme.zIndex.tooltip + 1 }}
            open={loading}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
};

export default BlockingSpinner;
